@if (isManualIconVisible) { @if (isHighlighted) {
<div
	class="text milestone-highlight"
	[attr.data-test-id]="'milestone-ready-cell-{{ index }}'"
	[matTooltipPosition]="'above'"
	[matTooltipClass]="'tooltip-events2'"
	[matTooltip]="milestoneToolTipText()"
>
	<app-icon
		class="icon"
		[name]="'tick-circle'"
		[size]="'24px'"
		[fill]="'var(--color-side-nav-background)'"
		[color]="'var(--color-basic-100)'"
	></app-icon>
</div>
} @else {
<div class="text milestone-highlight" [attr.data-test-id]="'milestone-ready-cell-{{ index }}'">
	<app-icon
		class="icon"
		[name]="'tick-circle'"
		[size]="'24px'"
		[fill]="'var(--color-basic-100)'"
		[color]="'var(--color-side-nav-background)'"
	></app-icon>
</div>
} }
